<div class="body">

    <table mat-table [dataSource]="(providerService.contracts$|async)|sortedObjectArray:active:direction:(providerService.contracts$|async)?.length" class="table" [matSortActive]="active" [matSortDirection]="direction" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="contractnumber">
            <th mat-header-cell mat-sort-header="contractnumber" *matHeaderCellDef>Nummer</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contractnumber}}

            </td>
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="5" class="footer">
                {{(providerService.contracts$|async)?.length}} Vertrag/Verträge
            </td>
        </ng-container>

        <ng-container matColumnDef="contractdesc">
            <th mat-header-cell mat-sort-header="contractdesc" *matHeaderCellDef>Titel</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contractdesc}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="contracttype">
            <th mat-header-cell mat-sort-header="contracttype" *matHeaderCellDef>Typ</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contracttype|contractType|async}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="contractstate">
            <th mat-header-cell mat-sort-header="contractstate" *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.contractstate|contractStatus|async}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="controls">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="control-cell">

                <button mat-icon-button (click)="showContract(element.value)">
                    <mat-icon>search</mat-icon>
                </button>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="body-row" [class.danger]="row.value.contractstate === 2"></tr>
        <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

    </table>

</div>
